











import {ChartDataTemplate, WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {bus} from '@/main'
import {defineComponent, reactive} from "@vue/composition-api"
import {getLocationCaption} from "@/data/sources/appraisal"
import {getStoredProcedure} from "@/data/repos/storedProcedure"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.KeyValue(),
    widget: "CarterMetricsUtilisation",
    title: "Carter Metrics Utilisation",
    _description: "",
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
    },
  }
}

async function dataFetcher(params: any) {
  return {
    data: await getStoredProcedure(
      'AnalyticsCenter',
      'widget_CarterUtilisation',
      [parseInt(params.locationId && params.locationId.value || "10"), 1], noValueFilter),
  }
}

function noValueFilter(data: any[]): any[] {
  const filteredData = []
  for (const item of data) {
    filteredData.push({
      ...item,
      Color: item.Label == 'No value!' ? '#C50000' : null,
    })
  }
  return filteredData
}

function getChartDataConfig() {
  return reactive({
      ...ChartDataTemplate(),
      // paletteColors: "#6baa01, #DC143C, #FFBF00",
      showZeroPies: "1",
      showPercentValues: "1",
      showPercentInTooltip: "1",
      animation: "0",
    },
  )
}

async function titleCallback(config: any) {
  return "Location: " + await getLocationCaption(config.params.locationId)
}


async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
  config && (chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId))
}

export default defineComponent({
  props: {config: Object},
  components: {FusionChartWidget},
  setup(props, context) {
    context.emit("config-update", config())

    function chartClickCallback() {
      const locationId = parseInt(props.config && props.config.params.locationId.value)
      bus.$emit('chartPopup', {
        title: 'Carter Metrics Utilisation',
        component: () => import('@/components/drilldowns/CarterUtilizationDrillDown.vue'),
        componentArgs: {
          locationId,
        },
      })
    }

    return {dataFetcher, getChartDataConfig, configChangeCallback, chartClickCallback}
  },
})
